module.exports = __webpack_public_path__ + "static/tube-desktop@2x-38e111dfdac4bc706dd96ce13d70b344.png";